import React from 'react';
import { EventStats } from 'types';
import { LineChartGradients } from 'utils/helpers/lineChart';
import moment from 'moment';
import _ from 'lodash';

interface LineChartElementProps {
  lineProps: EventStats[];
  convertMinsToHrsMins: (minute: number) => string;
  days: string[];
  idx: number;
}

const LineChartElement: React.FC<LineChartElementProps> = ({
  lineProps,
  days,
  idx,
  convertMinsToHrsMins,
}) => {
  const leftBarValue = _.sumBy(lineProps, (o) =>
    !o.isOnline ? o.duration : 0
  );
  const rightBarValue = _.sumBy(lineProps, (o) =>
    o.isOnline ? o.duration : 0
  );

  return (
    <>
      <div className="table__chart">
        <div className="chart__day">
          {!_.isEmpty(days) && moment(days[idx], 'DD-MM-YYY').format('ddd')}
        </div>
        <div
          className="chart__bar"
          style={{
            gridTemplateColumns: `${Math.round(leftBarValue) || 1}fr ${
              Math.round(rightBarValue) || 1
            }fr`,
            backgroundImage: LineChartGradients.onlineOfflineComparison.right,
          }}
        >
          <div
            className="chart__bar__item left"
            style={{
              backgroundImage: LineChartGradients.onlineOfflineComparison.left,
            }}
          >
            {convertMinsToHrsMins(leftBarValue)}
          </div>
          <div
            className="chart__bar__item right"
            style={{
              backgroundImage: LineChartGradients.onlineOfflineComparison.right,
            }}
          >
            {convertMinsToHrsMins(rightBarValue)}
          </div>
        </div>
        <div className="chart__hours">
          {convertMinsToHrsMins(rightBarValue + leftBarValue)}
        </div>
      </div>
    </>
  );
};

export default LineChartElement;
